<form [formGroup]="formGroup" autocomplete="off">
  <div class="row">
    <div class="col-md-5">
      <label class="margin-top-20">Credential Nick Name <i class="fa fa-asterisk required"></i></label>
    </div>
    <div class="col-md-7">
      <input type="text" class="form-control" name="name" formControlName="name" />
    </div>
  </div>
  <div class="row">
    <div class="col-md-5">
      <label class="margin-top-20">API base Url <i class="fa fa-asterisk required"></i></label>
    </div>
    <div class="col-md-7">
      <input type="text" class="form-control" name="apiBaseUrl" formControlName="apiBaseUrl" />
    </div>
  </div>
  <div class="row">
    <div class="col-md-5">
      <label class="margin-top-20">Login <i class="fa fa-asterisk required"></i></label>
    </div>
    <div class="col-md-7">
      <input type="text" class="form-control" name="clientId" formControlName="clientId" />
    </div>
  </div>
  <div class="row">
    <div class="col-md-5">
      <label class="margin-top-20">Password <i class="fa fa-asterisk required"></i></label>
    </div>
    <div class="col-md-7">
      <input type="text" class="form-control" name="clientSecret" formControlName="clientSecret" />
    </div>
  </div>
  <div class="row">
    <div class="col-md-5">
      <label class="margin-top-20">Company <i class="fa fa-asterisk required"></i></label>
    </div>
    <div class="col-md-7">
      <input type="text" class="form-control" name="scope" formControlName="scope" />
    </div>
  </div>

</form>